module.exports = __webpack_public_path__ + "static/midground-8901170da4a4512f413a0a73a8df1f4b.webp";